<template>
  <div class="word-list6">
    <div
      class="head"
      :style="{
        backgroundImage: 'url(' + dataInfo.cover + ')'
      }"
    >
      {{ dataInfo.name }}
    </div>
    <div class="g-box">
      <div class="content">
        <div
          class="item"
          :class="i % 2 ? 'reserve' : ''"
          v-for="(item, i) in dataList"
          :key="item.id"
        >
          <div class="item-le">
            <img :src="item.image" :alt="item.title" class="img" />
          </div>
          <div class="item-ri">
            <div class="title">{{ item.title }}</div>
            <div class="subtitle">{{ item.subtitle }}</div>
            <div class="line"></div>
            <div class="info">{{ item.tips }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageMain_mx from "../../mixins/pageMain_mx";

export default {
  data() {
    return {
      query: this.$route.query,
      dataInfo: {},
      dataList: []
    };
  },
  mixins: [pageMain_mx],
  components: {},
  mounted() {},
  methods: {
    async init() {
      const data = await this.getMenuList({
        pageNum: 1,
        pageSize: 999,
        menuId: this.query.id
      });
      this.dataList = data;
      const dataInfo = await this.getMenuInfo(this.query.id);
      this.dataInfo = dataInfo;
      console.log(dataInfo, "dataInfo");
    }
  }
};
</script>
<style lang="less">
.word-list6 {
  .head {
    height: 280px;
    // width: 1920px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 60px;
    color: #fff;
    letter-spacing: 40px;
  }
  .content {
    padding-bottom: 80px;

    .item {
      padding-top: 80px;
      display: flex;
      &-le {
        margin-right: 60px;
        .img {
          display: block;
          width: 480px;
          height: 300px;
        }
      }
      &-ri {
        .title {
          font-size: 26px;
          color: #000;
          line-height: 38px;
        }
        .subtitle {
          padding-top: 10px;
          font-size: 16px;

          color: #989da3;
          line-height: 22px;
        }
        .line {
          margin-top: 30px;
          width: 62px;
          height: 2px;
          background: #979797;
        }
        .info {
          padding-top: 50px;
          font-size: 16px;
          color: #1f1f1f;
          width: 660px;
          line-height: 26px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 5;
          white-space: normal;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
    .item.reserve {
      flex-direction: row-reverse;
      .item-le {
        margin-right: 0;
        margin-left: 60px;
      }
    }
  }
}
</style>
